import { Shimmer } from "shared/components";
import {
  Center,
  CenterProps,
  Divider,
  Flex,
} from "styled-system/jsx";

export const ReservationLoading = (props: CenterProps) => {
  return (
    <Center w="100%" h="100%" {...props}>
      <Flex flexDir="column" alignItems="center" gap="400" w="full">
        <Shimmer w="100%" h="80px" />
        <Divider />
        <Shimmer w="100%" h="120px" />
        <Divider />
        <Shimmer w="100%" h="200px" />
        <Shimmer w="100%" h="120px" />
        <Shimmer w="100%" h="360px" />
        <Shimmer w="100%" h="60px" />
        <Shimmer w="100%" h="500px" />
      </Flex>
    </Center>
  );
};
